module.exports = __webpack_public_path__ + "img/xlh-network.8ecb674.eed49f62.svg";